import helpers from "../utils/helpers";
import Common from "./common";

window.recaptchaQCFOnloadCallback = function () {
  grecaptcha.render("recaptcha_element", {
    sitekey: recaptcha_key,
    size: "invisible",
    badge: "inline",
    callback: QCF.challange,
  });
};

const QCF = {
  init: function () {
    var qcf_dom = $(".qcf");
    var qcf_form = qcf_dom.find(".qcf__form");
    if (qcf_form.length) {
      var scrolled = $(window).scrollTop();
      $(qcf_form).on("submit", function (e) {
        e.preventDefault();
        $(".error", this).removeClass("error");
        if (helpers.validate($(this), true)) {
          grecaptcha.execute();
        }
      });

      qcf_form.on("click", ".qcf__message--error button", function (e) {
        e.preventDefault();
        qcf_form.find(".qcf__message").removeClass("qcf__message--active");
      });

      qcf_dom.on("click", ".qcf__button", function (e) {
        e.preventDefault();

        qcf_dom.find(".qcf__message").removeClass("qcf__message--active");
        qcf_dom.find(".qcf__popup").addClass("qcf__popup--active");
        scrolled = $(window).scrollTop();
        $("html").addClass("no-scroll");
        $("body").scrollTop(scrolled);
      });

      qcf_dom.on("click", ".js-close", function (e) {
        e.preventDefault();
        qcf_dom.find(".qcf__popup").removeClass("qcf__popup--active");
        $("html").removeClass("no-scroll").scrollTop(scrolled);
      });

      $(document).on("keydown", function (event) {
        if (event.key == "Escape") {
          qcf_dom.find(".qcf__popup").removeClass("qcf__popup--active");
          $("html").removeClass("no-scroll").scrollTop(scrolled);
        }
      });
    }
  },

  challange: function (token) {
    if (token) {
      QCF.submit(token);
    }
    grecaptcha.reset();
  },

  submit: function (token) {
    var qcf_dom = $(".qcf");
    var qcf_form = qcf_dom.find(".qcf__form");
    var form_data = {
      qcf_name: qcf_form.find("#name").val(),
      qcf_company: qcf_form.find("#company").val(),
      qcf_phone: qcf_form.find("#phone").val(),
      qcf_email: qcf_form.find("#email").val(),
      qcf_topic: qcf_form.find("#topic").val(),
      qcf_message: qcf_form.find("#message").val(),
    };
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: {
        action: "submit_qcf",
        form_data: form_data,
        qcf_nonce: qcf_form.find("#qcf-nonce").val(),
        qcf_honey: qcf_form.find("#qcf-honey").val(),
        qcf_token: token,
      },
      beforeSend: function () {
        qcf_form.find(".qcf__message").removeClass("qcf__message--active");
        qcf_form.addClass("qcf__form--loading");
      },
      success: function (response) {
        // console.log(response);
        qcf_form.removeClass("qcf__form--loading");
        if (response.success) {
          qcf_form[0].reset();
          grecaptcha.reset();
          qcf_form.find("input, textarea").blur();
          qcf_form
            .find(".qcf__message--success")
            .addClass("qcf__message--active");
        } else {
          qcf_form
            .find(".qcf__message--error")
            .addClass("qcf__message--active");
        }
      },
    });
  },
};

export default QCF;
